import { render } from "./EmptyBox.vue?vue&type=template&id=d1df2610"
import script from "./EmptyBox.vue?vue&type=script&lang=js"
export * from "./EmptyBox.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__